import { deleteProjectGroup } from "actions/projectGroup/deleteProjectGroup";
import { listProjectGroup } from "actions/projectGroup/listProjectGroup";
import { get } from "lodash";
import React from "react";
import { connect } from "react-redux";
import DeleteProjectGroupPresenter from "./presenters";
import { useLocation } from "react-router";
import { apiService } from "constants/axiosInstance";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ProjectGroupDelete({
  selectedProjectGroup = null,
  open,
  setOpen,
  redirectURL = null,
  doDeleteProjectGroup,
  doReloadProjectGroup,
}) {
  const query = useQuery();
  const groupID = query.get("groupID");
  if (open) {
    console.log(open, redirectURL, groupID, "redirectURL open abc");
  }
  return (
    <DeleteProjectGroupPresenter
      doReloadProjectGroup={doReloadProjectGroup}
      open={open}
      setOpen={setOpen}
      groupID={groupID}
      handleDeleteProjectGroup={async () => {
        const config = {
          url: "/project-group/detail",
          method: "get",
          params: {
            project_group_id: get(selectedProjectGroup, "id"),
          },
        };
        if (
          !get(selectedProjectGroup, "id") ||
          get(selectedProjectGroup, "id") === ""
        )
          return;
        const response = await apiService(config);
        const group = response?.data?.project_group;
        doDeleteProjectGroup({
          projectGroupId: get(selectedProjectGroup, "id"),
          parentId: group?.parent?.id,
        });
      }}
      redirectURL={redirectURL}
    />
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    doReloadProjectGroup: () => dispatch(listProjectGroup(true)),
    doDeleteProjectGroup: ({ projectGroupId, parentId }) =>
      dispatch(deleteProjectGroup({ projectGroupId, parentId })),
  };
};

export default connect(null, mapDispatchToProps)(ProjectGroupDelete);
